import BasicContentSimpleStat from './BasicContentSimpleStat';

export { type BasicContentSimpleStatProps } from './BasicContentSimpleStat';
export default BasicContentSimpleStat;
